export enum Country {
    CZ = 'cz',
    SK = 'sk',
    ES = 'es',
    IT = 'it',
}
